import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServiceRespone } from 'src/app/model/serviceResponse';
import { NuovoUtente } from 'src/app/pages/admin-page/models/nuovoUtente';
import { AppConstants } from 'src/environments/constants';
import { CommonUtils } from 'src/utils/CommonUtils';
import { msConfig } from '../ms-config';
import { IUtentiService } from './IUtentiService';

@Injectable({
  providedIn: 'root'
})
export class UtentiService implements IUtentiService {

  constructor(private http: HttpClient) { }

  insertUser(nuovoUtente: NuovoUtente): Observable<ServiceRespone> {
    let url = msConfig['ms-utenti'] + AppConstants.PATH_UTENTE;
    let params: any = {};
    params.applicazione = 'EDITH';

    return this.http
      .post(url, nuovoUtente, { params })
      .pipe(map((resp: ServiceRespone) => {
        let users;
        users = resp;
        return users;
      }), catchError(CommonUtils.errorHandler))
  }

  eliminaUtente(ridp: string): Observable<ServiceRespone> {
    let url = msConfig['ms-utenti'] + AppConstants.PATH_UTENTE;
    let params: any = {};
    params.ridp = ridp
    params.applicazione = 'EDITH';

    return this.http
      .delete(url, params = { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }), catchError(CommonUtils.errorHandler))
  }

  modificaUtente(nuovoUtente: NuovoUtente): Observable<ServiceRespone> {
    let url = msConfig['ms-utenti'] + AppConstants.PATH_UTENTE;
    let params: any = {};
    params.applicazione = 'EDITH';

    return this.http
      .put(url, nuovoUtente, { params })
      .pipe(map((resp: ServiceRespone) => {
        let users;
        users = resp;
        return users;
      }), catchError(CommonUtils.errorHandler))
  }

  getUsers(tipologiaUtente: string[]): Observable<ServiceRespone> {
    let url = msConfig['ms-utenti'] + AppConstants.PATH_UTENTI + '/nomi';
    let params: any = {};
    params.tipologiaUtente = tipologiaUtente

    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let users;
        users = resp;
        return users;
      }), catchError(CommonUtils.errorHandler))
  }
}
